import { KEY, Resource } from "shelving";

export const PUBLISH_MEDIA = new Resource("publishMedia", KEY, KEY);
